import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, TemplateRef } from '@angular/core';
import { IonicModule } from '@ionic/angular/lazy';

import { DeploymentStore } from '@/shared/lib/stores/deployment.store';
import { NotificationStore } from '@/shared/lib/stores/notification.store';

@Component({
  selector: 'ods-page-header',
  imports: [IonicModule, NgTemplateOutlet],
  templateUrl: './page-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class PageHeaderComponent {
  deploymentStore = inject(DeploymentStore);
  notificationStore = inject(NotificationStore);

  readonly pageTitle = input<string>('cloudOTDR');
  // Replaces the deployment name below the title when set
  readonly subTitle = input<string | null>();
  readonly customActionsTemplate = input<TemplateRef<unknown>>();
}
